import React from "react"

import { withQuote } from "./withQuote"
import { Icon } from "../../../Icon/Icon"
import { StyledColumn } from "../../../Styled/Column"
import { StyledRow } from "../../../Styled/Row"
import { Blockquote, Small } from "../../../Styled/Text"
import { Section } from "./QuoteStyles"

export const Quote = withQuote(
  ({ author, quote }): JSX.Element => (
    <Section>
      <StyledRow items={`start`} justify={`between`} gutter={`sm`}>
        <StyledColumn screen={`<sm`} width={`no-shrink`} gutter={`sm`}>
          <Icon name={`quote`} width={22} />
        </StyledColumn>
        <StyledColumn screen={`md>`} width={`no-shrink`} gutter={`sm`}>
          <Icon name={`quote`} width={34} />
        </StyledColumn>
        <StyledColumn width={`grow`} gutter={`sm`}>
          <Blockquote withSpacing={`md`}>{quote}</Blockquote>
          <Small colour={`grey-dark`} normal>
            {author}
          </Small>
        </StyledColumn>
      </StyledRow>
    </Section>
  )
)

export default Quote
